import React from 'react';
import Layout from '~/components/layout/_layout';
import SEO from '~/components/seo';
import PageTypes from '~/page_types.ts';
import FadeInSection from '~/components/fadeinSection';
import { t } from '@lingui/macro';
import WhyBusiness from "../src/components/personal/WhyBusinessPersonal";
import {withI18n} from "@lingui/react";
import HowItWorksPersonal from "../src/components/personal/HowItWorksPersonal";
import HaveAQuestion from '~/components/homepage/haveAQuestion.jsx';
import ReferenceSection from '../src/components/personal/ReferenceSectionPersonal';

function PersonalPage() {
    const pageSections = [
        <WhyBusiness />,
        <HowItWorksPersonal />,
        <ReferenceSection/>,
        <HaveAQuestion supportContact={true} whiteBg='white'/>
    ];
    return (
        <Layout welcome={true} page={PageTypes.PERSONAL}>
            <SEO
                title={t`page.personal.seo.title`}
                description={t`page.personal.seo.description`}
            />
            {pageSections.map((section, id) => {
                return <FadeInSection key={id}>{section}</FadeInSection>;
            })}
        </Layout>
    );
}

export default withI18n()(PersonalPage);
